import banner from "../assets/4.jpg";


export const clinicInfo = {
  name: "Kavlekar Dental",
  tagline: "Implant & Microscopic Dentistry",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_20349391-8f16-4abb-ad89-1d87507d730e/artifacts/dyxlqpfw_WhatsApp%20Image%202026-03-06%20at%208.34.13%20PM.jpeg",
  whatsappNumber: "919844835587",
  whatsappMessage:
    "Hello Kavlekar Dental, I would like to book a consultation.",
  address:
    "05, 2nd Floor, Kothari Holdings, above Style Union, Vidya Nagar Main Road, Sirur Park, Hubballi, Karnataka 580021",
  phone: "+91 98448 35587",
  hours: [
    "Mon – Fri: 10:30 AM – 06:00 PM",
    "Saturday: 10:30 AM – 06:30 PM",
    "Sunday: Closed",
  ],
  rating: "5.0/5.0 Google Rating",
};

export const pageHeroImages = {
  home:
    "https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=2000&q=80",
  about: banner,
  services:
    "https://www.sevaoralhealth.com/wp-content/uploads/2025/10/services_hero_banner_desktop.jpg",
  caseStudies:
    "https://images.unsplash.com/photo-1571772996211-2f02c9727629?auto=format&fit=crop&w=2000&q=80",
  papers:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=2000&q=80",
  blogs:
    "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=2000&q=80",
  contact:
    "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=2000&q=80",
};

export const getWhatsappUrl = () => {
  const encoded = encodeURIComponent(clinicInfo.whatsappMessage);
  return `https://wa.me/${clinicInfo.whatsappNumber}?text=${encoded}`;
};
